/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentStatusDetailsV1Reason {
    UNKNOWN_ERROR = 'UnknownError',
    AUTHENTICATION_FAILED_CREDENTIALS_BLOCKED = 'AuthenticationFailed_CredentialsBlocked',
    AUTHENTICATION_FAILED_INVALID_CREDENTIALS = 'AuthenticationFailed_InvalidCredentials',
    AUTHENTICATION_FAILED_CREDENTIAL_RENEWAL_NEEDED = 'AuthenticationFailed_CredentialRenewalNeeded',
    AUTHENTICATION_FAILED_KEYCARD_RENEWAL_NEEDED = 'AuthenticationFailed_KeycardRenewalNeeded',
    AUTHENTICATION_FAILED_EXTERNAL_AUTHENTICATION_TIMEOUT = 'AuthenticationFailed_ExternalAuthenticationTimeout',
    AUTHENTICATION_FAILED_TIMEOUT = 'AuthenticationFailed_Timeout',
    AUTHENTICATION_FAILED_USER_CANCELLED = 'AuthenticationFailed_UserCancelled',
    AUTHENTICATION_FAILED_AUTHENTICATION_METHOD_DISABLED = 'AuthenticationFailed_AuthenticationMethodDisabled',
    PAYMENT_FAILED_INSUFFICIENT_FUNDS = 'PaymentFailed_InsufficientFunds',
    PAYMENT_FAILED_MAXIMUM_AMOUNT_EXCEEDED = 'PaymentFailed_MaximumAmountExceeded',
    PAYMENT_FAILED_DESTINATION_ACCOUNT_NOT_FOUND = 'PaymentFailed_DestinationAccountNotFound',
    PAYMENT_FAILED_DESTINATION_ACCOUNT_INVALID = 'PaymentFailed_DestinationAccountInvalid',
    PAYMENT_FAILED_EXECUTION_DATE_OUT_OF_RANGE = 'PaymentFailed_ExecutionDateOutOfRange',
    PAYMENT_FAILED_EXECUTION_DATE_NOT_BANKING_DAY = 'PaymentFailed_ExecutionDateNotBankingDay',
    PAYMENT_FAILED_EXECUTION_TYPE_NOT_AVAILABLE = 'PaymentFailed_ExecutionTypeNotAvailable',
    PAYMENT_FAILED_DESTINATION_NAME_INVALID = 'PaymentFailed_DestinationNameInvalid',
    PAYMENT_FAILED_SOURCE_ACCOUNT_INVALID = 'PaymentFailed_SourceAccountInvalid',
    PAYMENT_FAILED_IDENTIFIER_INVALID = 'PaymentFailed_IdentifierInvalid',
    PAYMENT_FAILED_PAYMENT_NOT_FOUND_AT_PROVIDER = 'PaymentFailed_PaymentNotFoundAtProvider',
    PAYMENT_FAILED_INVALID_MODEL = 'PaymentFailed_InvalidModel',
    PAYMENT_FAILED_NO_PAYMENT_ACCOUNTS = 'PaymentFailed_NoPaymentAccounts',
    PAYMENT_FAILED_INVALID_CURRENCY = 'PaymentFailed_InvalidCurrency',
}